"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=logoConfig.js.map